import { forwardRef, TextareaHTMLAttributes } from 'react';
import { Input } from '../input';
import { StyledTextArea } from './styled';

export type TextAreaProps = {
  label?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => {
    return (
      <Input label={props.label} name={props.name}>
        <StyledTextArea ref={ref} {...props} />
      </Input>
    );
  }
);
